function calculateColorPercentage(value, percent) {
  const v = Math.round(Number(value) + Number(value) * (percent / 100));
  if (v >= 255) {
    return 'ff';
  }
  if (v <= 0) {
    return '00';
  }
  if ((v.toString(16)).length === 1) {
    return `0${v.toString(16)}`;
  }
  return v.toString(16);
}

export function getRelativeColorByPercent(color, percent) {
  const r = Number(`0x${color.slice(1,3)}`);
  const g = Number(`0x${color.slice(3,5)}`);
  const b = Number(`0x${color.slice(5,7)}`);

  const newR = calculateColorPercentage(r, percent);
  const newG = calculateColorPercentage(g, percent);
  const newB = calculateColorPercentage(b, percent);

  return `#${newR}${newG}${newB}`;
}

